module.exports = __webpack_public_path__ + "img/madness_600.603ab896.png";